import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { FuseDeleteDialogComponent } from '../../../../core/components/delete-dialog/delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { EventService } from '../../../../core/services/event.service';
import { forkJoin } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import * as fileSaver from 'file-saver';
import ExcelJS from 'exceljs';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sub-event-participant',
  templateUrl: './sub-event-participant.component.html',
  styleUrls: ['./sub-event-participant.component.scss'],
  standalone: false
})
export class SubEventParticipantComponent implements OnInit {
  @Input() public subEvents;
  @Input() public participants;
  @Input() public eventId;
  @Input() public eventData;
  displayedColumns = ['event.participants'];
  displayedColumnsDescription: any = {};
  dataSource = [];
  defaultDataSource = [];
  priorityRange: any = {};
  priorityRangeDef: any = [];
  subEventIds: any = [];
  wasEdited = false;
  editInProgress = false;
  tempElement;
  maxParticipants: any = {};
  minParticipants: any = {};
  maxParticipantsError = false;
  eventFinished = false;
  startTime: any = {};
  endTime: any = {};
  constructor(public dialog: MatDialog, public eventService: EventService,
              private spinner: NgxSpinnerService, public toastr: ToastrService,
              public translate: TranslateService) {
  }

  ngOnInit() {
    if (this.eventData) {
      this.eventFinished = this.eventData.finishBooking;
    }
    if (this.subEvents) {
      this.maxParticipants = {};
      this.minParticipants = {};
      this.startTime = {};
      this.endTime = {};
      this.displayedColumns = ['event.participants'];
      let users = [];
      for (let i = 0; i < this.subEvents.length; i++) {
        let startTime: any = '';
        let endTime: any = '';
        this.maxParticipants[this.subEvents[i].id] = this.subEvents[i].maxParticipants;
        this.minParticipants[this.subEvents[i].id] = this.subEvents[i].minParticipants;
        if (this.subEvents[i].date && this.subEvents[i].fromTime) {
          const [day, month, year] = this.subEvents[i].date.split('.').map(Number);
          const [hours, minutes] = this.subEvents[i].fromTime.split(':').map(Number);
          const dateObject = new Date(year, month - 1, day, hours, minutes);
          startTime = dateObject.getTime();
        }
        if (this.subEvents[i].date && this.subEvents[i].toTime) {
          const [day, month, year] = this.subEvents[i].date.split('.').map(Number);
          const [hours, minutes] = this.subEvents[i].toTime.split(':').map(Number);
          const dateObject = new Date(year, month - 1, day, hours, minutes);
          endTime = dateObject.getTime();
        }
        this.subEventIds.push(this.subEvents[i].id);
        this.priorityRangeDef.push((this.subEvents.length - i));
        this.displayedColumns.push(this.subEvents[i].id.toString());
        this.displayedColumnsDescription[this.subEvents[i].id] = this.subEvents[i].title;
        for (let j = 0; j < this.subEvents[i].subEventBooking.length; j++) {
          let participant = this.subEvents[i].subEventBooking[j];
          if (participant?.frontUser) {
            let index = users.findIndex(user => user.id === participant.frontUser.id);
            if (index === -1) {
              users.push({
                id: participant?.frontUser.id,
                name: participant?.frontUser.firstName + ' ' + participant?.frontUser.lastName,
                [this.subEvents[i].id]: participant?.priority,
                [this.subEvents[i].id + '_createdAt']: moment(participant?.createdAt).valueOf(),
                isFrontUser: true,
                createdAt: moment(participant?.createdAt).valueOf(),
                [this.subEvents[i].id + '_startTime']: startTime,
                [this.subEvents[i].id + '_endTime']: endTime,
                highPriority: participant?.priority,
                highPriorityEvent: this.subEvents[i].id
              });
            } else {
              users[index][this.subEvents[i].id] = participant?.priority;
              users[index][this.subEvents[i].id + '_createdAt'] = moment(participant?.createdAt).valueOf();
              users[index][this.subEvents[i].id + '_startTime'] = startTime;
              users[index][this.subEvents[i].id + '_endTime'] = endTime;
              if (+participant?.priority > +users[index].highPriority) {
                users[index].highPriority = participant?.priority;
                users[index].highPriorityEvent = this.subEvents[i].id;
              }
            }
          } else if (participant?.guestUsers) {
            let index = users.findIndex(user => user.id === participant.guestUsers.id);
            if (index === -1) {
              users.push({
                id: participant?.guestUsers.id,
                name: participant?.guestUsers.firstName + ' ' + participant?.guestUsers.lastName,
                [this.subEvents[i].id]: participant?.priority,
                [this.subEvents[i].id + '_createdAt']: moment(participant?.createdAt).valueOf(),
                isFrontUser: false,
                createdAt: moment(participant?.createdAt).valueOf(),
                [this.subEvents[i].id + '_startTime']: startTime,
                [this.subEvents[i].id + '_endTime']: endTime,
                highPriority: participant?.priority,
                highPriorityEvent: this.subEvents[i].id
              });
            } else {
              users[index][this.subEvents[i].id] = participant?.priority;
              users[index][this.subEvents[i].id + '_createdAt'] = moment(participant?.createdAt).valueOf();
              users[index][this.subEvents[i].id + '_startTime'] = startTime;
              users[index][this.subEvents[i].id + '_endTime'] = endTime;
              if (+participant?.priority > +users[index].highPriority) {
                users[index].highPriority = participant?.priority;
                users[index].highPriorityEvent = this.subEvents[i].id;
              }
            }
          }
        }
      }

      this.dataSource = users.sort((a, b) => a.createdAt - b.createdAt);
      this.defaultDataSource = JSON.parse(JSON.stringify(this.dataSource));
      console.log(users);
      this.displayedColumns.push('edit');
      this.checkMaxParticipants();
    }
  }

  checkMaxParticipants() {
    this.maxParticipantsError = false;
    for (let i = 0; i < this.subEvents.length; i++) {
      let count = this.dataSource.filter(el => el.hasOwnProperty(this.subEvents[i].id)).length;
      if ((count > this.maxParticipants[this.subEvents[i].id]) && !!this.maxParticipants[this.subEvents[i].id]) {
        this.maxParticipantsError = true;
      }
    }
  }

  editSubEventParticipant(element) {
    this.tempElement = JSON.parse(JSON.stringify(element));
    this.getAvailablePriorityRange(element);
    element.editing = true;
    this.wasEdited = true;
    this.editInProgress = true;
  }

  cancelEditSubEventParticipant(element) {
    element.editing = false;
    element = Object.assign(element, this.tempElement);
    let keys = Object.keys(element);
    for (let i = 0; i < keys.length; i++) {
      if (!this.tempElement.hasOwnProperty(keys[i])) {
        delete element[keys[i]];
      }
    }
    this.tempElement = null;
    this.editInProgress = false;
  }

  saveEditSubEventParticipant(element) {
    element.editing = false;
    this.editInProgress = false;
    this.checkMaxParticipants();
    this.checkHighestPriority(element);
  }

  checkHighestPriority(element) {
    for (let i = 0; i < this.subEventIds.length; i++) {
      if (element[this.subEventIds[i]] && +element[this.subEventIds[i]] >= +element.highPriority) {
        element.highPriority = element[this.subEventIds[i]];
        element.highPriorityEvent = this.subEventIds[i];
      }
    }
  }

  changeSelect(element, colId, value) {
    if (value) {
      element[colId] = value;
      element[colId + '_manual'] = true;
    } else {
      delete element[colId];
      delete element[colId + '_manual'];
    }
    this.getAvailablePriorityRange(element);
  }

  getAvailablePriorityRange(element) {
    let priorityRange = [...this.priorityRangeDef];
    for (let i = 0; i < this.subEventIds.length; i++) {
      if (element[this.subEventIds[i]]) {
        this.priorityRange[this.subEventIds[i]] = [element[this.subEventIds[i]]];
        const index = priorityRange.indexOf(element[this.subEventIds[i]]);
        if (index !== -1) {
          priorityRange.splice(index, 1);
        }
      } else {
        this.priorityRange[this.subEventIds[i]] = [];
      }
    }
    for (let i = 0; i < this.subEventIds.length; i++) {
      this.priorityRange[this.subEventIds[i]] = this.priorityRange[this.subEventIds[i]].concat(priorityRange).sort((a, b) => b - a);
      this.priorityRange[this.subEventIds[i]].unshift('');
    }
  }

  cancelChanges() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'event.rollback' , message: 'event.cancel_changes'}
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
          this.dataSource = JSON.parse(JSON.stringify(this.defaultDataSource));
          this.wasEdited = false;
          this.checkMaxParticipants();
      }
    });
  }

  saveChanges() {
    this.spinner.show();
    let requests = [];
    for (let i = 0; i < this.dataSource.length; i++) {
      if (this.dataSource[i].hasOwnProperty('editing')) {
        for (let j = 0; j < this.subEventIds.length; j++) {
          let data: any = {
            subEventId: this.subEventIds[j],
            createdAt: new Date(this.dataSource[i].createdAt)
          };
          if (this.dataSource[i].isFrontUser) {
            data.frontUserId = this.dataSource[i].id;
          } else {
            data.guestUsersId = this.dataSource[i].id;
          }
          if (this.dataSource[i].hasOwnProperty(this.subEventIds[j].toString())) {
            data.priority = this.dataSource[i][this.subEventIds[j]];
            requests.push(this.eventService.editSubEventBooking(data));
          } else {
            requests.push(this.eventService.removeSubEventBookingByAdmin(data));
          }
          if (this.dataSource[i].hasOwnProperty(this.subEventIds[j] + '_manual')) {
            delete this.dataSource[i][this.subEventIds[j] + '_manual'];
          }
        }
        delete this.dataSource[i]['editing'];
      }
    }
    if (requests.length) {
      forkJoin(requests).subscribe({
        next: (res) => {
          this.wasEdited = false;
          this.defaultDataSource = JSON.parse(JSON.stringify(this.dataSource));
          this.dataSource = null;
          setTimeout(() => {
            this.dataSource = JSON.parse(JSON.stringify(this.defaultDataSource));
          });
          this.spinner.hide();
        },
        error: (err) => {
          console.error('At least one request failed', err);
          this.spinner.hide();
        }
      });
    } else {
      this.wasEdited = false;
      this.spinner.hide();
    }
  }

  finishBooking() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , {
      panelClass: 'unsave-form-dialog',
      width: '500px' , height: 'auto',
      data: {title: 'event.finish_booking' , message: 'event.finish_booking_question'}
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.eventService.finishBooking(this.eventId).subscribe((result) => {
          if (result) {
            this.getSubEventForBooking();
          }
        });
      }
    });
  }

  getSubEventForBooking() {
    this.eventService.getSubEventForBooking(this.eventId).subscribe((res: any) => {
      if (res) {
        this.eventFinished = true;
        this.eventData.finishBooking = true;
        this.subEvents = res;
      }
    });
  }

  autoFix(){
    this.spinner.show();
    for (let i = 0; i < this.subEvents.length; i++) {
      let booking = this.dataSource.filter(el => el.hasOwnProperty(this.subEvents[i].id));
      if ((booking.length > this.maxParticipants[this.subEvents[i].id]) && !!this.maxParticipants[this.subEvents[i].id]) {
        booking = booking.sort((a, b) => {
          if (+a[this.subEvents[i].id] !== +b[this.subEvents[i].id]) {
            return b[this.subEvents[i].id] - a[this.subEvents[i].id];
          }
          return a[this.subEvents[i].id + '_createdAt'] - b[this.subEvents[i].id + '_createdAt'];
        });
        for (let j = this.maxParticipants[this.subEvents[i].id]; j < booking.length; j++) {
          delete booking[j][this.subEvents[i].id];
          delete booking[j][this.subEvents[i].id + '_createdAt'];
          booking[j]['editing'] = false;
          this.wasEdited = true;
        }
      }
    }
    let tempData = JSON.parse(JSON.stringify(this.dataSource));
    for (let i = 0; i < this.subEventIds.length; i++) {
      this.checkHighestPriority(tempData[i]);
    }
    this.dataSource = JSON.parse(JSON.stringify(tempData));
    this.checkMaxParticipants();
    this.spinner.hide();
  }

  getColor(id) {
    let count = this.dataSource.filter(el => el.hasOwnProperty(id)).length;
    if ((count > this.maxParticipants[id]) && !!this.maxParticipants[id]) {
      return 'rgba(255, 0, 0, 0.5)';
    } else {
      return 'transparent';
    }
  }

  getColorByTime(element, eventId) {
    if (element[eventId + '_startTime'] && element[eventId + '_endTime'] && element[eventId]) {
      const targetStart = element[`${eventId}_startTime`];
      const targetEnd = element[`${eventId}_endTime`];
      const otherIds = Object.keys(element)
        .filter(key => key.endsWith('_startTime') && !key.startsWith(`${eventId}_`))
        .map(key => key.split('_')[0]);
      for (const id of otherIds) {
        const currentStart = element[`${id}_startTime`];
        const currentEnd = element[`${id}_endTime`];
        const currentValue = element[`${id}`];

        if (currentStart && currentEnd && currentValue) {
          if (targetStart < currentEnd && currentStart < targetEnd) {
            return 'rgba(255, 127, 0, 0.5)';
          }
        }
      }
    }
    return 'transparent';
  }

  downloadExcel(subEvent) {
    let xlsArray = subEvent.subEventBooking.map((el) => {
      let user = {};
      if (el.frontUserId) {
        user = {
          Vorname: el.frontUser.firstName,
          Nachname: el.frontUser.lastName,
          'Mobile-Nr.' : el.frontUser.mobile,
          'E-Mail': el.frontUser.email,
        };
      } else {
        user = {
          Vorname: el.guestUsers.firstName,
          Nachname: el.guestUsers.lastName,
          'Mobile-Nr.' : el.guestUsers.mobile,
          'E-Mail': el.guestUsers.email,
        };
      }
      return user;
    });
    const header = Object.keys(xlsArray[0]);
    let workbook = new ExcelJS.Workbook();

    workbook.creator = 'Ipeak';
    workbook.lastModifiedBy = 'Ipeak';
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();
    workbook.properties.date1904 = true;
    workbook.views = [
      {
        x: 0, y: 0, width: 10000, height: 20000,
        firstSheet: 0, activeTab: 1, visibility: 'visible'
      }
    ];
    let worksheet = workbook.addWorksheet(subEvent.title);
    let worksheetHeader = header.map(el => {
      return {header: el, key: el, width: 32};
    });
    worksheet.columns = worksheetHeader;
    worksheet.addRows(xlsArray);
    workbook.xlsx.writeBuffer()
      .then((data) => {
        let blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        fileSaver.saveAs(blob, subEvent.title + '.xlsx');
      });
  }

  sendNotification() {
    let checkSuEvents = this.subEvents.filter(el => !!el.notificationSent);
    if (checkSuEvents.length > 0) {
      const dialogRef = this.dialog.open(FuseDeleteDialogComponent , {
        panelClass: 'unsave-form-dialog',
        width: '400px' , height: 'auto',
        data: {title: 'event.inform_participants' , message: 'event.inform_participants_msg'}
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res) {
          this.sendNotificationFunc();
        }
      });
    } else {
      this.sendNotificationFunc();
    }
  }

  sendNotificationFunc() {
    this.eventService.sendNotification(this.eventId).subscribe({
      next: (res) => {
        let title = this.translate.instant('successfully');
        let msg = this.translate.instant('event.notification_sent');
        this.toastr.success(msg, title);
        this.subEvents.forEach(subEvent => { subEvent.notificationSent = true; });
      },
      error: (err) => {
        let title = this.translate.instant('failure');
        let msg = this.translate.instant('api_error');
        this.toastr.error(title , msg);
      }
    });
  }
}
